export default class CommentsController {
  constructor ($scope, $interval, $cookies, chatboxServices, Messages) {
    var vm = this

  // Variables declaradas
    vm.minimizeContact = true
    vm.id = 0
    vm.showMessageBoxes = true
    vm.messages = []
    vm.showMessageWindow = true
    vm.messageWindow = {}
    vm.conversations = []
    vm.messageReceive = {}
    vm.chatsWindows = []
    vm.messageHistoryReceive = []
    vm.btnSend = {'keyCode': 13}
    vm.messageBoxes = true

    $interval(function () {
      vm.currentTime = new Date()
    }, 1)

    let getCurrentUser = $interval(function () {
      let cookieUser = $cookies.getObject('currentUser')
      if (cookieUser) {
        vm.userLogin = cookieUser
        Messages.user({id: 'comments_' + vm.userLogin.id, name: vm.userLogin.name})
        vm.idRol = $cookies.getObject('hasRoleId')
        activate()
        $interval.cancel(getCurrentUser)
      }
    }, 1000)

    // Funciones
    vm.sendMessage = sendMessage
    vm.menssages = menssages
    vm.checktime = checktime
    vm.closeContacts = closeContacts

    Messages.receive(function (message, isPrivate) {
      let i = vm.chatContacts.findIndex(chat => {
        return chat.contactUserId === message.user.id
      })

      if (!vm.messageWindow[message.user.id]) {
        vm.messageWindow[message.user.id] = {
          idUser: message.user.id, // Consulta completa de contactos
          userName: vm.chatContacts[i].userName,
          onLine: vm.chatContacts[i].onLine, // Debe estar integrado con la consulta del contacto
          information: [],
          showMessageWindow: false,
          delete: false,
          new: 1
        }

        vm.id = message.user.id
        vm.messageHistoryReceive = vm.messageHistory.filter(menssages)

        if (vm.messageHistoryReceive.length !== 0) {
          vm.messageHistoryReceive = vm.messageHistoryReceive.map(objeto => {
            objeto.from = objeto.senderId !== message.user.id ? vm.chatContacts[i].userPicture : vm.chatUser[0].userPicture
            objeto.classChat = objeto.senderId !== message.user.id ? 'friend' : 'self'
            objeto.send = 1
            return objeto
          })

          vm.messageWindow[message.user.id].information = vm.messageHistoryReceive
        }

        vm.messageReceive = ({
          'from': vm.chatContacts[i].userPicture,
          'classChat': 'friend',
          'dateTime': vm.currentTime,
          'dateDay': checktime(vm.currentTime),
          'data': message.data,
          'send': 1
        })

        vm.messageWindow[message.user.id].information.push(vm.messageReceive)

        vm.conversations.unshift(vm.messageWindow[message.user.id])
        return
      }

      vm.messageReceive = ({
        'from': vm.chatContacts[i].userPicture,
        'classChat': 'friend',
        'dateTime': vm.currentTime,
        'dateDay': checktime(vm.currentTime),
        'data': message.data,
        'send': 1
      })

      vm.messageWindow[message.user.id].new = vm.messageWindow[message.user.id].showMessageWindow ? 0 : 1
      vm.messageWindow[message.user.id].information.push(vm.messageReceive)

      let indx = vm.conversations.findIndex(chat => {
        return chat.idUser === message.user.id
      })

      if (indx >= 3) {
        vm.conversations.splice(indx, 1)
        vm.conversations.unshift(vm.messageWindow[message.user.id])
      }

      if (indx === -1) { vm.conversations.unshift(vm.messageWindow[message.user.id]) }
    })

    function activate () {
      getChatUser()
      getChatContacts()
    }

    function getChatUser () {
      return chatboxServices.getChatUserById.get({userId: vm.userLogin.id}).$promise.then((dataResult) => {
        if (dataResult.status === true) {
          vm.chatUser = dataResult.data
          vm.chatUser[0].onLine = 1
        } else {
          vm.chatUser = []
        }
      }).catch((error) => { console.error(error) })
    }

    function getChatContacts () {
      let rol
      if (vm.idRol === 3 || vm.idRol === 8 || vm.idRol === 9) {
        rol = 'EVALUATOR'
      } else if (vm.idRol === 13) {
        rol = 'TEACHER'
      } else {
        return
      }

      let params = {
        userId: vm.userLogin.id,
        rolName: rol
      }
      return chatboxServices.getChatContacts.get(params).$promise.then((dataResult) => {
        if (dataResult.status === true) {
          vm.chatContacts = dataResult.data.chatContacts.map(chatContact => {
            chatContact.status = chatContact.onLine === 1 ? 'Conectado' : 'Desconectado'
            return chatContact
          })
          vm.messageHistory = dataResult.data.messageHistory
        } else {
          vm.chatContacts = []
          vm.messageHistory = []
        }
      }).catch((error) => { console.error(error) })
    }

    function sendMessage (event, to, text) {
      if (!text) return
      if (event.keyCode !== 13) return
      var message = {
        from: vm.chatUser[0].userPicture,
        to: to,
        data: text,
        user: Messages.user(),
        classChat: 'self',
        dateTime: vm.currentTime,
        dateDay: checktime(vm.currentTime),
        send: 0
      }
      vm.messageWindow[to].information.push(message)
      vm.messageWindow[to].newComment = ''
      vm.messageWindow[to].new = 0

      let post = {
        chatMessage: text,
        senderUser: to,
        receiverUser: vm.userLogin.id
      }

      return chatboxServices.addUserMessage.post(post).$promise.then((dataResult) => {
        if (dataResult.status === true) {
          message.send = 1
          Messages.send(message)
        } else {
          vm.chatContacts = []
        }
      }).catch((error) => { console.error(error) })
    }

    function closeContacts (bool) {
      vm.closeContact = bool
    }

    function menssages (objeto) {
      return objeto.senderId === vm.id || objeto.receiverId === vm.id
    }

    function checktime (time) {
      vm.currentTime = moment(vm.currentTime).format('YYYY-MM-DD')
      time = moment(time).format('YYYY-MM-DD')
      var dia = ''
      var init = moment(vm.currentTime)
      var end = moment(time)
      var diff = init.diff(end, 'days')

      switch (diff) {
        case 0:
          dia = 'HOY'
          break
        case 1:
          dia = 'AYER'
          break
        default: dia = moment(time).format('DD-MM-YYYY')
      }
      return dia
    }
  }// Fin del constructor

  minimizeContacs (bool) {
    console.log('holaaaaaa')
    this.minimizeContact = bool
  }

  newChat (data) {
    if (!this.messageWindow[data.contactUserId]) {
      this.messageWindow[data.contactUserId] = {
        idUser: data.contactUserId, // Consulta completa de contactos
        userName: data.userName,
        onLine: data.onLine,
        information: [],
        showMessageWindow: true,
        delete: false,
        new: 0
      }

      this.id = data.contactUserId
      this.messageHistoryCreate = this.messageHistory.filter(this.menssages)

      if (this.messageHistoryCreate.length !== 0) {
        this.messageHistoryCreate = this.messageHistoryCreate.map(objeto => {
          objeto.from = objeto.senderId !== data.contactUserId ? data.userPicture : this.chatUser[0].userPicture
          objeto.classChat = objeto.senderId !== data.contactUserId ? 'friend' : 'self'
          objeto.dateDay = this.checktime(objeto.dateTime)
          objeto.send = 1
          return objeto
        })
        this.messageWindow[data.contactUserId].information = this.messageHistoryCreate
      }
      this.conversations.unshift(this.messageWindow[data.contactUserId])
    } else {
      let i = this.conversations.findIndex(chat => {
        return chat.idUser === data.contactUserId
      })

      if (i >= 3) {
        this.conversations.splice(i, 1)
        this.conversations.unshift(this.messageWindow[data.contactUserId])
      }

      if (i === -1) { this.conversations.unshift(this.messageWindow[data.contactUserId]) }

      this.messageWindow[data.contactUserId].showMessageWindow = true
    }
  }

  minimizeChats (bool) {
    this.showMessageWindow = bool
  }

  closedChat (data) {
    let i = this.conversations.findIndex(chat => {
      return chat.idUser === data.idUser
    })
    this.conversations.splice(i, 1)
  }

  openedChat (data) {
    let i = this.conversations.findIndex(chat => {
      return chat.idUser === data.idUser
    })

    this.conversations.splice(i, 1)
    this.conversations.unshift(this.messageWindow[data.idUser])
  }

  showChatsBoxes (bool) {
  }

  showMessage (data) {
    data.showMessageWindow = true
    data.new = 0
  }
}

CommentsController.$inject = ['$scope', '$interval', '$cookies', 'chatboxServices', 'Messages']



// WEBPACK FOOTER //
// ./src/app/u-faculty/chatbox/comments/commentsController.js